// React
import { useMemo } from "react";

// Helpers
import { getValueFromData } from "@DataPages/components/Inventory/helpers/reconciliation";

// Constants
import { propertiesMap } from "@DataPages/components/Inventory/Tables/Reconciliation/SummaryTable/constants";

// Types
import { ISummaryDetail } from "@DataPages/types/inventory/models/reconciliation";
import { TReconciliationSummaryPropertyRow } from "@DataPages/types/inventory/commons";

type UseSummaryTransformedRowsProps = Readonly<{
	data: Partial<ISummaryDetail>;
	propertyRows: TReconciliationSummaryPropertyRow<ISummaryDetail>[];
}>;
export default function useSummaryTransformedRows(args: UseSummaryTransformedRowsProps) {
	return useMemo(() => {
		return args.propertyRows.map((key, idx) => {
			const value = getValueFromData(key.label, args.data);
			return {
				...key,
				_id: idx,
				value,
				key: propertiesMap[key.label],
				isFooter: key.isFooter,
			};
		});
	}, [args.data]);
}
